/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_TranslationInputs */

const en_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Translation`)
};

const fr_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer la traduction`)
};

const de_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung importieren`)
};

const it_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa traduzione`)
};

const ru_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт перевода`)
};

const es_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar traducción`)
};

const zh_cn2_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入翻译`)
};

const ja_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポート翻訳`)
};

const hi_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद आयात करें`)
};

const pt_pt2_import_translation = /** @type {(inputs: Import_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução de Importação`)
};

/**
* | output |
* | --- |
* | "Import Translation" |
*
* @param {Import_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_translation = /** @type {((inputs?: Import_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_import_translation(inputs)
	if (locale === "de") return de_import_translation(inputs)
	if (locale === "it") return it_import_translation(inputs)
	if (locale === "ru") return ru_import_translation(inputs)
	if (locale === "es") return es_import_translation(inputs)
	if (locale === "zh-CN") return zh_cn2_import_translation(inputs)
	if (locale === "ja") return ja_import_translation(inputs)
	if (locale === "hi") return hi_import_translation(inputs)
	if (locale === "pt-PT") return pt_pt2_import_translation(inputs)
	return en_import_translation(inputs)
});